const serviceNames = {
  facebook:    'Facebook',
  google:      'Google',
  nextdoor:    'Nextdoor',
  broadly:     'Broadly',
  tripadvisor: 'TripAdvisor',
  yelp:        'Yelp'
};

export function getServiceName(service) {
  return serviceNames[service];
}
